module.exports = __webpack_public_path__ + "static/media/Trebuchet MS-01.55afce2f.svg";